import * as React from "react";
import { useState, useEffect } from "react";
import {
  FormLabel,
  IconButton,
  Grid,
  Typography,
  TextField,
  Box,
  MenuItem,
  Select,
  Modal,
  Button,
  FormControl,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { createNewSite } from "../../services/siteServices/subSiteService";
import { getLocationByCity } from "../../services/siteServices/locationService";
import {
  getAllPrinciple,
  getPrincipleById,
  getPrincipleByPartnerId,
} from "../../services/siteServices/principleServices";
import {
  getAllCityByPrinciple,
  getAllCorporationByCity,
  getAllPackagesByPrincipleAndCity,
  getPackageByPrincipleAndPackageName,
} from "../../services/siteServices/packageServices";
import {
  getAllPartners,
  getAllPremiums,
} from "../../services/PartnerService/PartnerService";

const FormGrid = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px", // Added gap for spacing between label and input
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function AddNewSiteForm({ formData, setFormData }) {
  const navigate = useNavigate();
  const [editMode, setEditMode] = useState(true);
  const [cities, setCities] = useState([]);
  const [corporation, setCorporation] = useState([]);
  const [projects, setProjects] = useState([]);
  const [partners, setPartners] = useState({
    partner: [],
  });

  const [premiums, setPremiums] = useState([]);
  const [packages, setPackages] = useState([]);
  const [locationId, setLocationid] = useState("");
  const [project, setProject] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [newId, setNewId] = useState(null);

  useEffect(() => {
    fetchPartners();
    fetchPremiumness();
  }, []);

  async function fetchPartners() {
    try {
      const response = await getAllPartners();
      setPartners(response);
    } catch (error) {
      console.log("fetch Partners", error);
    }
  }

  async function fetchPremiumness() {
    try {
      const response = await getAllPremiums();
      setPremiums(response);
    } catch (error) {
      console.log("fetch Partners", error);
    }
  }

  const handleEditToggle = () => {
    // setEditMode(!editMode);
  };

  const fetchProjects = async () => {
    try {
      const projectResponse = await getAllPrinciple();
      const filteredProjectResponse = projectResponse?.filter((item, index) => {
        if (item.ProjectName != "SIL") {
          return item;
        }
      });
      setProjects(filteredProjectResponse);
    } catch (error) {
      console.log("fetchCities", error);
    }
  };

  const fetchCitiesByPrincipleName = async (name) => {
    try {
      const citiesResponse = await getAllCityByPrinciple(name); // Assuming `getCities` API returns a list of cities
      setCities(citiesResponse);
    } catch (error) {
      console.log("error in fetchPackages", error);
    }
  };
  const fetchPackagesByPrincipleAndCity = async (principle, city) => {
    try {
      const packagesResponse = await getAllPackagesByPrincipleAndCity(
        principle,
        city
      );

      setPackages(packagesResponse);
    } catch (error) {
      console.log("error in fetchPackages", error);
    }
  };

  const fetchCorporationByCity = async (name) => {
    try {
      const corporationResponse = await getAllCorporationByCity(name); // Assuming `getCities` API returns a list of cities
      setCorporation(corporationResponse);
    } catch (error) {
      console.log("error in fetchPackages", error);
    }
  };

  async function GetPrinciplesBasedOnPartner(event) {
    const partner = event.target.value;
    console.log("partner ", partner);

    if (partner) {
      setFormData((prev) => ({
        ...prev,
        partnerName: {
          error: false,
          errorMessage: "Partner Name required",
          value: partner,
        },
      }));
      const data = await getPrincipleByPartnerId(partner);
      setProjects(data);
    }
  }

  async function GetCorporationBasedOnCity(event) {
    const partner = event.target.value;
    console.log("partner ", partner);

    if (partner) {
      setFormData((prev) => ({
        ...prev,
        partnerName: {
          error: false,
          errorMessage: "Partner Name required",
          value: partner,
        },
      }));
      const data = await getPrincipleByPartnerId(partner);
      setProjects(data);
    }
  }

  async function GetBasedOnPartner(event) {
    const partner = event.target.value;
    console.log("partner ", partner);

    if (partner) {
      setFormData((prev) => ({
        ...prev,
        partnerName: {
          error: false,
          errorMessage: "Partner Name required",
          value: partner,
        },
      }));
      const data = await getPrincipleByPartnerId(partner);
      setProjects(data);
    }
  }
  const handleProjectChange = async (event) => {
    const selectedProject = event.target.value;
    console.log("event", event.target);
    console.log("selectedProject", selectedProject);
    // console.log("formData.projectName", formData.projectName);

    setFormData((prev) => ({
      ...prev,
      projectName: {
        ...prev.projectName,
        error: false,
        value: selectedProject,
        // error: hasError,
      },
    }));

    try {
      const projectDetails = await getPrincipleById(selectedProject);
      setProject(projectDetails.ProjectID);

      if (projectDetails) {
        setFormData((prev) => ({
          ...prev,
          desc: {
            ...prev.desc,
            error: false,
            value: projectDetails.ProjectDescription || "",
          },
        }));
        fetchCitiesByPrincipleName(selectedProject);
      }
    } catch (error) {
      console.log("error in handleProjectChange", error);
    }
  };

  useEffect(() => {
    // console.log("formdata---->", formData);
    // console.log("formdata-desc", formData.desc);
  }, [formData]);

  const handleCityChange = async (event) => {
    const selectedCity = event.target.value;

    setFormData((prev) => ({
      ...prev,
      city: {
        ...prev.city,
        value: selectedCity,
        error: false,
        // error: hasError,
      },
    }));

    try {
      const cityDetails = await getLocationByCity(selectedCity); // Fetch additional data based on the city
      setLocationid(cityDetails[0].LocationID);
      if (cityDetails) {
        setFormData((prev) => ({
          ...prev,
          state: {
            ...prev.state,
            value: cityDetails[0].StateName || "",
          },
          zone: {
            ...prev.zone,
            value: cityDetails[0].Zone || "",
          },
          profile: {
            ...prev.profile,
            value: cityDetails[0].Profile || "",
          },
          priority: {
            ...prev.priority,
            value: cityDetails[0].PriorityOfCity || "",
          },
        }));
      }
      fetchPackagesByPrincipleAndCity(formData.projectName.value, selectedCity);
      fetchCorporationByCity(selectedCity);
    } catch (error) {
      console.log("error in handleCityChange", error);
    }
  };

  const handlePackageChange = async (e) => {
    const { name, value } = e.target;
    let selectedPackage = e.target.value;

    setFormData((prev) => ({
      ...prev,
      package_name: {
        ...prev.package_name,
        error: false,
        value: selectedPackage,
      },
    }));

    try {
      const packageDetails = await getPackageByPrincipleAndPackageName(
        formData.projectName.value,
        selectedPackage
      );

      console.log("packageDetails----------------", packageDetails);
      if (packageDetails) {
        // Update state and zone based on the city details
        setFormData((prev) => ({
          ...prev,
          packageId: {
            ...prev.packageId,
            value: packageDetails.PackageID,
          },
          package_rate: {
            ...prev.package_rate,
            value: packageDetails.RatePerSQFT,
          },
          // packageId: packageDetails.PackageID,
          // // package_name: packageDetails.PackageName,
          // package_rate: packageDetails.RatePerSQFT,
        }));
      }
    } catch (error) {
      console.log("error in handlePackageChange", error);
    }
  };

  const handleCorporationChange = (event, newValue) => {
    let selectedCorporation = newValue?.corporationName || ""; // Adjust based on your data structure

    setFormData((prev) => ({
      ...prev,
      corporationName: {
        ...prev.corporationName,
        error: false,
        value: selectedCorporation,
      },
    }));
  };

  const handlePremiumnessChange = (event, newValue) => {
    console.log("Event:", event);
    console.log("New Value:", newValue);

    let selectedPremium = newValue?.name || "";
    setFormData((prev) => ({
      ...prev,
      premiumness: {
        ...prev.premiumness,
        error: false,
        value: selectedPremium,
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,

      [name]: {
        ...prev[name],
        // ...formData[name],
        value: value,
      },
    }));
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    navigate(`/projects/${newId}`);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("Updated data: ", formData, locationId, project);

    const formFields = Object.keys(formData);
    let newFormData = { ...formData };
    let hasError = false;

    // console.log("formdata------->", formData);

    // if (!formData.projectName.value) {
    //   console.log("cant submit");
    //   return;
    // }

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formData[currentField].value;

      if (currentValue === "") {
        newFormData = {
          ...newFormData,
          [currentField]: {
            ...newFormData[currentField],
            error: true, // Set error to true if the field is empty
          },
        };
        hasError = true; // Set hasError to true
      } else {
        // If the field is filled, clear the error
        // console.log(" newFormData[currentField]", newFormData[currentField]);
        newFormData[currentField].error = false;
      }
    }

    setFormData(newFormData);

    // if (!formData.projectName) {
    //   console.error("Project Name is required.");
    //   return; // Prevent submission if validation fails
    // }
    // console.log("formdata-------", formData);

    const obj = {
      ProjectID: project,
      LocationID: locationId,
      PackageID: formData.packageId.value,
      principleName: formData.projectName.value,
      cityName: formData.city.value,
      LocationName: formData.assetLocationName.value,
      LocationLandmark: formData.landmark.value,
      LocationLat: formData.latitude.value,
      LocationLong: formData.longitude.value,
      PrincipleUIDCode: formData.principleUid.value,
      package_name: formData.package_name.value,
      package_rate: formData.package_rate.value,
      corporationName: formData.corporationName.value,
      premiumness: formData.premiumness.value,
    };
    // console.log("obj", obj);

    try {
      // console.log("data coming", formData);
      if (!formData.partnerName.value) {
        return;
      }
      if (!formData.projectName.value) {
        return;
      }
      if (!formData.desc.value) {
        return;
      }
      if (!formData.city.value) {
        return;
      }
      if (!formData.package_name.value) {
        return;
      }
      if (!formData.corporationName.value) {
        return;
      }
      // if (!formData.premiumness.value) {
      //   return;
      // }

      const createSite = await createNewSite(obj);
      console.log("createSite", createSite);
      setNewId(createSite.SiteID);
      console.log("SIte id ", createSite.SiteID);

      if (createSite) {
        console.log("True ");

        setEditMode(false);
        setOpenModal(true);
      }
    } catch (error) {
      console.log("createSite", error);
    }
  };

  const onCancel = () => {
    navigate("/projects");
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Edit / Save / Cancel Buttons */}
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          {editMode ? (
            <Box display="flex" justifyContent="flex-end" gap={2} px={2}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ backgroundColor: "#b41660" }}
              >
                Create Site
              </Button>

              <Button
                variant="outlined"
                sx={{
                  border: "1px solid #b41660",
                  color: "#b41660",
                  "&:hover": {
                    borderColor: "#e91e63", // Lighter shade on hover
                    backgroundColor: "rgba(228, 53, 102, 0.1)", // Optional light background
                  },
                }}
                component="span"
                onClick={onCancel}
              >
                Cancel
              </Button>
            </Box>
          ) : (
            <IconButton onClick={handleEditToggle}>
              <EditIcon />
            </IconButton>
          )}
        </Grid>

        {/* Partner Name */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="city">Partner Name</FormLabel>
          {editMode ? (
            <FormControl
              fullWidth
              error={formData.partnerName.error}
              variant="outlined"
              size="small"
            >
              <Select
                id="partnerName"
                name="partnerName"
                value={formData.partnerName.value}
                onChange={GetPrinciplesBasedOnPartner}
                size="small"
                variant="outlined"
                required
              >
                {partners.partner.map((item) => (
                  <MenuItem
                    key={item.id}
                    // name={principle.ProjectID}
                    value={item.id}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              {formData.partnerName.error && (
                <FormHelperText>
                  {formData.partnerName.errorMessage}
                </FormHelperText>
              )}
            </FormControl>
          ) : (
            <Typography>{formData.partnerName.value}</Typography>
          )}
        </FormGrid>

        {/* Principle Name */}

        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="projectName" required>
            Principle Name
          </FormLabel>
          {editMode ? (
            <FormControl
              fullWidth
              error={formData.projectName.error}
              variant="outlined"
              size="small"
            >
              <Autocomplete
                id="projectName"
                options={projects}
                getOptionLabel={(option) => option.ProjectName || ""}
                value={
                  projects.find(
                    (principle) =>
                      principle.ProjectName === formData.projectName.value
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleProjectChange({
                    target: {
                      name: "projectName",
                      value: newValue?.ProjectName || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    required
                    error={formData.projectName.error}
                    helperText={
                      formData.projectName.error
                        ? formData.projectName.errorMessage
                        : ""
                    }
                  />
                )}
              />
            </FormControl>
          ) : (
            <Typography>{formData.projectName.value}</Typography>
          )}
        </FormGrid>

        {/* Status */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="status" required>
            Status
          </FormLabel>
          {editMode ? (
            <TextField
              disabled
              id="status"
              name="status"
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
              value={formData.status.value}
              error={formData.status.error}
              helperText={formData.status.error && formData.status.errorMessage}
            />
          ) : (
            <Typography>{formData.status.value}</Typography>
          )}
        </FormGrid>

        {/* desc */}
        <FormGrid xs={12} p={2}>
          <FormLabel htmlFor="desc" required>
            Description
          </FormLabel>
          {editMode ? (
            <TextField
              id="desc"
              name="desc"
              // value={formData.desc}?
              onChange={handleChange}
              multiline
              rows={4}
              variant="outlined"
              size="small"
              required
              value={formData.desc.value}
              error={formData.desc.error}
              helperText={formData.desc.error && formData.desc.errorMessage}
            />
          ) : (
            <Typography>{formData.desc.value}</Typography>
          )}
        </FormGrid>

        {/* Principle UID Code */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="principleUid">Principle UID Code</FormLabel>
          {editMode ? (
            <TextField
              id="principleUid"
              name="principleUid"
              // value={formData.principleUid}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
              value={formData.principleUid.value}
            />
          ) : (
            <Typography>{formData.principleUid.value}</Typography>
          )}
        </FormGrid>

        {/* City Dropdown */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="city" required>
            City
          </FormLabel>
          {editMode ? (
            <FormControl
              fullWidth
              error={formData.city.error}
              variant="outlined"
              size="small"
            >
              <Select
                id="city"
                name="city"
                onChange={handleCityChange}
                required
                value={formData.city.value}
              >
                {cities.map((city, index) => (
                  <MenuItem key={index} value={city.locationName}>
                    {city.locationName}
                  </MenuItem>
                ))}
              </Select>

              {formData.city.error && (
                <FormHelperText>{formData.city.errorMessage}</FormHelperText>
              )}
            </FormControl>
          ) : (
            <Typography>{formData.city.value}</Typography>
          )}
        </FormGrid>

        {/* State */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="state" required>
            State
          </FormLabel>
          {editMode ? (
            <TextField
              id="state"
              name="state"
              // value={formData.state}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
              disabled
              value={formData.state.value}
              error={formData.state.error}
              // helperText={formData.state.error && formData.state.errorMessage}
            />
          ) : (
            <Typography>{formData.state.value}</Typography>
          )}
        </FormGrid>
        {/* Package ID */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="package_name" required>
            Package Name
          </FormLabel>
          {editMode ? (
            <FormControl
              fullWidth
              error={formData.package_name.error}
              variant="outlined"
              size="small"
            >
              <Select
                id="package_name"
                name="package_name"
                onChange={handlePackageChange}
                required
                value={formData.package_name.value}
              >
                {packages.map((pack, index) => (
                  <MenuItem key={index} value={pack.packageName}>
                    {pack.packageName}
                  </MenuItem>
                ))}
              </Select>
              {formData.package_name.error && (
                <FormHelperText>
                  {formData.package_name.errorMessage}
                </FormHelperText>
              )}
            </FormControl>
          ) : (
            <Typography>{formData.packageId?.PackageName}</Typography>
          )}
        </FormGrid>

        {/* Zone */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="zone" required>
            Zone
          </FormLabel>
          {editMode ? (
            <TextField
              id="zone"
              name="zone"
              // value={formData.zone}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
              disabled
              value={formData.zone.value}
              error={formData.zone.error}
              // helperText={formData.zone.error && formData.zone.errorMessage}
            />
          ) : (
            <Typography>{formData.zone.value}</Typography>
          )}
        </FormGrid>

        {/* Profile */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="profile" required>
            Profile
          </FormLabel>
          {editMode ? (
            <TextField
              id="profile"
              name="profile"
              // value={formData.profile}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
              disabled
              value={formData.profile.value}
              error={formData.profile.error}
              // helperText={
              //   formData.profile.error && formData.profile.errorMessage
              // }
            />
          ) : (
            <Typography>{formData.profile.value}</Typography>
          )}
        </FormGrid>

        {/* Priority */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="priority" required>
            City Priority
          </FormLabel>
          {editMode ? (
            <TextField
              id="priority"
              name="priority"
              // value={formData.priority}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
              disabled
              value={formData.priority.value}
              error={formData.priority.error}
              // helperText={
              //   formData.priority.error && formData.priority.errorMessage
              // }
            />
          ) : (
            <Typography>{formData.priority.value}</Typography>
          )}
        </FormGrid>

        {/* Asset Location Name */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="assetLocationName">
            Principle Asset Location Name
          </FormLabel>
          {editMode ? (
            <TextField
              id="assetLocationName"
              name="assetLocationName"
              value={formData.assetLocationName.value}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
            />
          ) : (
            <Typography>{formData.assetLocationName.value}</Typography>
          )}
        </FormGrid>

        {/* Landmark */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="landmark">Landmark</FormLabel>
          {editMode ? (
            <TextField
              id="landmark"
              name="landmark"
              value={formData.landmark.value}
              onChange={handleChange}
              size="small"
              variant="outlined"
            />
          ) : (
            <Typography>{formData.landmark.value}</Typography>
          )}
        </FormGrid>

        {/* Latitude */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="latitude">Latitude</FormLabel>
          {editMode ? (
            <TextField
              id="latitude"
              name="latitude"
              value={formData.latitude.value}
              onChange={handleChange}
              size="small"
              variant="outlined"
            />
          ) : (
            <Typography>{formData.latitude.value}</Typography>
          )}
        </FormGrid>

        {/* Longitude */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="longitude">Longitude</FormLabel>
          {editMode ? (
            <TextField
              id="longitude"
              name="longitude"
              value={formData.longitude.value}
              onChange={handleChange}
              size="small"
              variant="outlined"
            />
          ) : (
            <Typography>{formData.longitude.value}</Typography>
          )}
        </FormGrid>

        {/* Corporation Name */}
        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="corporationName" required>
            Corporation Name
          </FormLabel>
          {editMode ? (
            <FormControl
              fullWidth
              error={formData.corporationName.error}
              variant="outlined"
              size="small"
            >
              <Autocomplete
                id="corporationName"
                options={corporation}
                getOptionLabel={(option) => option.corporationName || ""}
                value={
                  corporation.find(
                    (option) =>
                      option.corporationName === formData.corporationName.value
                  ) || null
                }
                onChange={(event, newValue) =>
                  handleCorporationChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    required
                    error={formData.corporationName.error}
                    helperText={
                      formData.corporationName.error
                        ? formData.corporationName.errorMessage
                        : ""
                    }
                  />
                )}
              />
            </FormControl>
          ) : (
            <Typography>{formData.corporationName.value}</Typography>
          )}
        </FormGrid>

        {/* Premiumness dropdown */}
        {/* <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="premiumness" required>
            Premiumness
          </FormLabel>
          {editMode ? (
            <FormControl
              fullWidth
              error={formData.projectName.error}
              variant="outlined"
              size="small"
            >
              <Autocomplete
                id="premiumness"
                options={premiumness}
                getOptionLabel={(option) => option.premiumness || ""}
                value={
                  projects.find(
                    (principle) =>
                      principle.premiumness === formData.premiumness.value
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleProjectChange({
                    target: {
                      name: "premiumness",
                      value: newValue?.premiumness || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    required
                    error={formData.premiumness.error}
                    helperText={
                      formData.premiumness.error
                        ? formData.premiumness.errorMessage
                        : ""
                    }
                  />
                )}
              />
            </FormControl>
          ) : (
            <Typography>{formData.premiumness.value}</Typography>
          )}
        </FormGrid> */}

        <FormGrid xs={12} md={6} p={2}>
          <FormLabel htmlFor="premiumness" required>
            Premiumness
          </FormLabel>
          {editMode ? (
            <FormControl
              fullWidth
              error={formData.premiumness.error}
              variant="outlined"
              size="small"
            >
              <Autocomplete
                id="premiumness"
                options={premiums} // Ensure `premiumness` array matches the expected structure
                getOptionLabel={(option) => option.name || ""}
                value={
                  premiums.find(
                    (option) => option.name === formData.premiumness.value
                  ) || null
                }
                onChange={(event, newValue) =>
                  handlePremiumnessChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    required
                    // error={formData.premiumness.error}
                    // helperText={
                    //   formData.premiumness.error
                    //     ? formData.premiumness.errorMessage
                    //     : ""
                    // }
                  />
                )}
              />
            </FormControl>
          ) : (
            <Typography>{formData.premiumness.value}</Typography>
          )}
        </FormGrid>

        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-title" variant="h6" component="h2">
              Success!
            </Typography>
            <Typography id="modal-description" sx={{ mt: 2 }}>
              The site has been created successfully.
            </Typography>
            <Button
              onClick={handleCloseModal}
              variant="contained"
              sx={{
                mt: 2,
                minWidth: "120px",
                borderColor: "#b41660",
                backgroundColor: "#b41660",
                "&:hover": {
                  backgroundColor: "#a00e50",
                },
              }}
            >
              Ok
            </Button>
          </Box>
        </Modal>

        {/* Add spacing between sections */}
        <Box mt={2} />
      </Grid>
    </Box>
  );
}
